import { useOrganisationsContext } from '@/context/OrganisationsContext';

export const useTakenTeamSeats = () => {
    const { organisationActiveInvitations, members } =
        useOrganisationsContext();

    const takenSeats = members.length + organisationActiveInvitations.length;

    return {
        takenSeats,
    };
};
